// extracted by mini-css-extract-plugin
export default {"progress":"Progress_progress__eXTTu","progressnum":"Progress_progressnum__FULXF"};